module.exports = __webpack_public_path__ + "static/portfolio-img4-c7e05de4854e50b2d72b5f705578c759.jpg";